import { render, staticRenderFns } from "./comments-display-comp.vue?vue&type=template&id=66dfff5b&"
import script from "./comments-display-comp.vue?vue&type=script&lang=js&"
export * from "./comments-display-comp.vue?vue&type=script&lang=js&"
import style0 from "./comments-display-comp.vue?vue&type=style&index=0&id=66dfff5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports